module.exports = __webpack_public_path__ + "b679df282cd2a70fd0049767e16c6bfb.webp";